module.exports = __webpack_public_path__ + "static/jc04657-preparation-administration-3-7f6d1e11c58a402642c63514925c4142.png";